'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearRecipientTimeout = exports.setRecipientTimeout = exports.closeConversationFailed = exports.closeConversationSucceededAction = exports.dismissProfileTip = exports.clickProfileTip = exports.closeConversation = exports.setChatFilterAction = undefined;
exports.setChatFilter = setChatFilter;
exports.closeConversationSucceeded = closeConversationSucceeded;
exports.closeCurrentChannel = closeCurrentChannel;

var _transmute = require('transmute');

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _ChatActions = require('conversations-core/actions/ChatActions');

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _MessagesClient = require('conversations-core/data/MessagesClient');

var _conversationSelectors = require('conversations-core/selectors/conversationSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setChatFilterAction = exports.setChatFilterAction = (0, _reduxActions.createAction)(_ActionTypes2.default.SET_CHAT_FILTER);
function setChatFilter(newChatFilter) {
  return function (dispatch, getState) {
    var currentFilter = (0, _transmute.getIn)(['adminUi', 'chatFilter'], getState());
    var conversationsMatchingFilter = (0, _conversationSelectors.getConversationsByStatusType)(getState(), newChatFilter);
    var firstChannelMatchingNewFilter = (0, _transmute.get)('channel', conversationsMatchingFilter.first());

    var shouldSelectFirstConversation = newChatFilter !== currentFilter;

    if (shouldSelectFirstConversation) {
      var channelToSet = firstChannelMatchingNewFilter || null;
      dispatch((0, _ChatActions.setCurrentChannel)(channelToSet));
    }

    dispatch(setChatFilterAction({ newChatFilter: newChatFilter }));
  };
}

var closeConversation = exports.closeConversation = (0, _reduxActions.createAction)(_ActionTypes2.default.CLOSE_CONVERSATION);

var clickProfileTip = exports.clickProfileTip = (0, _reduxActions.createAction)(_ActionTypes2.default.CLICK_PROFILE_TIP);

var dismissProfileTip = exports.dismissProfileTip = (0, _reduxActions.createAction)(_ActionTypes2.default.DISMISS_PROFILE_TIP);

var closeConversationSucceededAction = exports.closeConversationSucceededAction = (0, _reduxActions.createAction)(_ActionTypes2.default.CLOSE_CONVERSATION_SUCCEEDED);

function closeConversationSucceeded(channel) {
  return function (dispatch) {
    dispatch((0, _ChatActions.selectNextChannelForStatus)(channel));
    dispatch(closeConversationSucceededAction(channel));
  };
}

var closeConversationFailed = exports.closeConversationFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.CLOSE_CONVERSATION_FAILED);

var setRecipientTimeout = exports.setRecipientTimeout = (0, _reduxActions.createAction)(_ActionTypes2.default.SET_RECIPIENT_TIMEOUT);

var clearRecipientTimeout = exports.clearRecipientTimeout = (0, _reduxActions.createAction)(_ActionTypes2.default.CLEAR_RECIPIENT_TIMEOUT);

function closeCurrentChannel(currentChannel) {
  return function (dispatch) {
    dispatch(closeConversation());
    return (0, _MessagesClient.closeConversationByChannel)(currentChannel).then(function () {
      dispatch(closeConversationSucceeded(currentChannel));
      dispatch((0, _ConversationsActions.endConversation)(currentChannel));
    }, function (err) {
      dispatch(closeConversationFailed(err));
    }).done();
  };
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/AdminUIActions.js
// module id = 269
// module chunks = 0